import { RefObject, useEffect, useRef } from 'react';

export default function useScrollToElem(): RefObject<HTMLDivElement> {
  const elem = useRef<HTMLDivElement>(null);

  useEffect(() => {
    elem.current?.scrollIntoView(false);
  });

  return elem;
}
